import React from "react";
import FooterSection from "../../components/sections/FooterSection";

function TermsOfServicePage(props) {
    return (
        <>
            <div className="uk-container uk-margin-large-top">
                <h1>Terms of Service</h1>

                <p><strong>Effective Date:</strong> [27 Aug 2025]</p>

                <section>
                    <h2>1. Scope of Services</h2>
                    <ol>
                        <li>The Company publishes informational content, organizes tours, and provides visa consulting and processing services.</li>
                        <li>Accounts are not mandatory for browsing but are required for most services, including consulting and visa processing.</li>
                        <li>Services are provided to both natural persons and business entities. Minimum age of participation is 16 years.</li>
                    </ol>
                </section>

                <section>
                    <h2>2. User Accounts</h2>
                    <ol>
                        <li>Account creation requires a valid email address and password. Passwords are stored in hashed form.</li>
                        <li>Identification relies on JSON Web Tokens (JWT). The browser only stores language preference; cookies are not used.</li>
                        <li>Accounts may be deleted by Users at any time. Deletion takes effect within 24 hours. Financial records are retained for regulatory purposes, while personal data is deleted in accordance with Section 7.</li>
                        <li>The Company may suspend or delete accounts that are inactive, or accounts suspected of DDoS or other malicious activity.</li>
                    </ol>
                </section>

                <section>
                    <h2>3. Payments and Refunds</h2>
                    <ol>
                        <li>Payments are accepted in USD via bank transfer, Kaspi, or card.</li>
                        <li>Services are offered on a one-time purchase basis. No subscriptions are offered.</li>
                        <li>
                            Refunds:
                            <ol>
                                <li>If a User cancels prior to service delivery, a full refund is issued except for non-recoverable bank charges.</li>
                                <li>If a visa is refused, government fees already paid are not refundable, but the Company refunds its service fees proportionally.</li>
                                <li>Consulting services are refunded for unused minutes.</li>
                            </ol>
                        </li>
                        <li>Refunds are processed within a reasonable timeframe following User request.</li>
                    </ol>
                </section>

                <section>
                    <h2>4. Content and Intellectual Property</h2>
                    <ol>
                        <li>Users may upload avatars and submit reviews of tours and staff.</li>
                        <li>Reviews are moderated prior to publication. Avatars must represent real faces; anime or non-human images are not accepted.</li>
                        <li>Reviews and avatars may be removed upon request by either the uploader or the individual depicted in the avatar.</li>
                        <li>Users retain the right to delete their reviews and avatars. Once published, the Company assumes ownership responsibility for content displayed on the website.</li>
                        <li>All website code and infrastructure (including React.js and Node.js applications) are the sole intellectual property of the Company.</li>
                    </ol>
                </section>

                <section>
                    <h2>5. Prohibited Activities</h2>
                    <ol>
                        <li>The following activities are prohibited:
                            <ol>
                                <li>DDoS attacks or interference with the website infrastructure.</li>
                                <li>Fraudulent payments or attempts to misuse services.</li>
                            </ol>
                        </li>
                        <li>Scraping of website content is expressly permitted.</li>
                    </ol>
                </section>

                <section>
                    <h2>6. Service Availability and Liability</h2>
                    <ol>
                        <li>The website and services are provided "as is" without warranty, except as expressly provided in Section 3 regarding financial refunds.</li>
                        <li>The Company is not responsible for:
                            <ol>
                                <li>Downtime, data loss, or technical errors. Users may be required to resubmit documents if data is lost.</li>
                                <li>Decisions made by embassies, consulates, or other government agencies regarding visas.</li>
                            </ol>
                        </li>
                        <li>The Company responds to clients through messengers (for example, WhatsApp) even in case of website downtime.</li>
                    </ol>
                </section>

                <section>
                    <h2>7. Data Protection and Privacy</h2>
                    <ol>
                        <li>The Company complies with applicable data protection laws, including GDPR (EU) and CCPA (California).</li>
                        <li>Data is stored in encrypted form in MongoDB Atlas (Ireland) and in Almaty, Kazakhstan.</li>
                        <li>Anonymous analytics data is collected via Google Analytics and Yandex Metrica. No unregistered User is identified.</li>
                        <li>Upon account deletion:
                            <ol>
                                <li>Personal data is erased within 24 hours.</li>
                                <li>Financial records are retained for at least six weeks for compliance and reporting, and may be provided to the User upon request.</li>
                            </ol>
                        </li>
                    </ol>
                </section>

                <section>
                    <h2>8. Termination</h2>
                    <ol>
                        <li>Users may terminate accounts at any time via account settings.</li>
                        <li>The Company may terminate or suspend accounts in cases of inactivity, technical misuse, or violation of these Terms.</li>
                    </ol>
                </section>

                <section>
                    <h2>9. Governing Law and Jurisdiction</h2>
                    <ol>
                        <li>These Terms are governed exclusively by the laws of the Republic of Kazakhstan.</li>
                        <li>Any disputes arising under these Terms shall be subject to the jurisdiction of the courts located in Astana, Kazakhstan.</li>
                    </ol>
                </section>

                <section>
                    <h2>10. Amendments to Terms</h2>
                    <ol>
                        <li>The Company may amend these Terms from time to time.</li>
                        <li>Notification of changes is provided via WhatsApp, SMS, the User's account dashboard, and optionally via Telegram and email if requested. Continued use of services constitutes acceptance of revised Terms.</li>
                    </ol>
                </section>

                <section>
                    <h2>11. Contact Information</h2>
                    <p>For any inquiries regarding these Terms, services, or disputes, contact the Company via:</p>
                    <ul>
                        <li>WhatsApp (calls and messages): +77750912804 (Buba Jallow)</li>
                        <li>Registered office: Korgalzhyn Highway 19T, "Korgalzhyn Business Center" Astana, Republic of Kazakhstan</li>
                    </ul>
                </section>
            </div>
            <FooterSection />
        </>
    );
}

export default TermsOfServicePage;
